import { paginatedTransform } from 'src/services/skuit/utils'
import { Attachment, PaginatedResponse, Tag } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

class Tags {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Tag>> => {
    const response = await this.api.get('/documents/tags', config)
    return paginatedTransform(Tag)(response.data)
  }
}

export class Attachments {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Attachment>> => {
    const response = await this.api.get('/shipments/attachments', config)
    return paginatedTransform(Attachment)(response.data)
  }

  get tags() {
    const api = new Tags(this.api)
    Object.defineProperty(this, 'tags', { value: api })
    return api
  }
}
